import uiI18n from "../i18n";
import { apiRequest, ApiError, getCurrentUser } from "./apiClient";
import { BIEN_API_FIELDS, bienSubmissionFields } from "./bienEditModel";

export function availableListings(data) {
  if (Array.isArray(data)) return data.filter((item) => !item.isDeleted);
  if (data?.items) return { ...data, items: availableListings(data.items) };
  return data;
}

export async function publicListings(path) {
  return availableListings(await apiRequest(path, { authenticated: false }));
}

export async function listingById(type, id) {
  if (!id) throw new ApiError(404, uiI18n.t("ui.missing_listing_id"));
  const listing = await apiRequest(`${type}/${encodeURIComponent(id)}`, { authenticated: false });
  if (!listing || listing.isDeleted) throw new ApiError(404, uiI18n.t("ui.this_listing_is_no_longer_available"));
  return listing;
}

export async function saveListing(type, data, files = [], update = false) {
  const user = await getCurrentUser();
  const fields = Object.fromEntries(Object.entries(data).map(([key, value]) => [key.toLowerCase(), value]));
  if (update) {
    const stored = await listingById(type, fields.id);
    if ((stored.uid ?? stored.Uid) !== user.uid) throw new ApiError(403, uiI18n.t("ui.you_do_not_own_this_listing_643"));
  }
  if (type === 'Vacation') {
    const price = fields.prix == null || String(fields.prix).trim() === '' ? 0 : Number(fields.prix);
    if (!Number.isFinite(price) || price < 0 || price > 50000000) throw new ApiError(400, uiI18n.t('vacationPublication.invalidPrice'));
    if ((fields.offre === true || fields.offre === 'true') && !(price > 0 && Number(fields.prixreduit) > 0 && Number(fields.prixreduit) < price))
      throw new ApiError(400, uiI18n.t('vacation.invalid_discount'));
    // Preserve the existing numeric contract; never post an empty string to decimal model binding.
    data = { ...data };
    const priceKey = Object.keys(data).find(key => key.toLowerCase() === 'prix') || 'Prix';
    data[priceKey] = price;
    const retained = update ? fields.allimages ?? fields.urlimages ?? '' : '';
    const count = (Array.isArray(retained) ? retained : String(retained).split(',')).filter(Boolean).length;
    const added = Array.from(files || []).filter(file => file instanceof Blob).length;
    if (count + added > 12 && (!update || added > 0)) throw new ApiError(400, uiI18n.t('vacationPublication.imageLimit', { count: 12 }));
  }
  const form = new FormData();
  if (type === 'Biens') {
    const model = bienSubmissionFields(data);
    Object.entries(BIEN_API_FIELDS).forEach(([key, apiKey]) => {
      if (key !== 'uid' && key !== 'urlImages' && model[key] !== undefined) {
        form.set(apiKey, model[key] === null ? '' : String(model[key]));
      }
    });
    // Publisher public name is stored once at creation; edits never rewrite it.
    if (!update && typeof data.name === 'string' && data.name.trim()) form.set('Name', data.name.trim());
  } else Object.entries(data).forEach(([key, value]) => {
    if (value != null && !["uid", "images", "files", "allimages", "urlimages", "isdeleted"].includes(key.toLowerCase())) {
      form.set(key, String(value));
    }
  });
  form.set("uid", user.uid);
  if (update) {
    // Keep only retained server filenames; new files are appended by the backend.
    const retained = fields.allimages ?? fields.urlimages ?? "";
    if (typeof retained !== 'string' && (!Array.isArray(retained) || retained.some(image => typeof image !== 'string'))) {
      throw new Error('Invalid retained image filenames');
    }
    form.set("allImages", Array.isArray(retained) ? retained.join(",") : retained);
    form.set("UrlImages", Array.isArray(retained) ? retained.join(",") : retained);
  }
  Array.from(files || []).filter((file) => file instanceof Blob).forEach((file) => form.append("files", file));
  return apiRequest(`${type}/${update ? "Update" : "Add"}${type === "Biens" ? "Bien" : "Vacation"}`, {
    method: update ? "PUT" : "POST", body: form,
  });
}
